import AppBarh from "../components/AppBarh";
import Footer from "../components/Footer";
import { Box, Typography } from "@mui/material";
import * as React from "react";

const Refund = () => {
  const wrapper: React.CSSProperties = {
    maxWidth: "900px",
    margin: "40px auto",
    padding: "30px",
    backgroundColor: "#ffffff",
    border: "1px solid #ddd",
    borderRadius: "10px",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    color: "#333",
  };

  const title: React.CSSProperties = {
    fontSize: "22px",
    fontWeight: "bold",
    textAlign: "center",
    marginBottom: "30px",
    color: "#1a202c",
  };

  const heading: React.CSSProperties = {
    fontSize: "16px",
    fontWeight: 600,
    marginTop: "30px",
    marginBottom: "10px",
    color: "#2d3748",
  };

  const paragraph: React.CSSProperties = {
    fontSize: "14px",
    lineHeight: "1.7",
    marginBottom: "20px",
    textAlign: "justify",
  };

  const list: React.CSSProperties = {
    paddingLeft: "20px",
    fontSize: "14px",
    marginBottom: "20px",
  };

  const listItem: React.CSSProperties = {
    marginBottom: "8px",
  };

  const email: React.CSSProperties = {
    color: "#0073e6",
    textDecoration: "none",
  };

  return (
  <div className="Example">
          <AppBarh/>

    <div style={wrapper}>
      <h1 style={title}>Refund Policy</h1>

      <p style={paragraph}>
        At the Uva Wellassa University Alumni Association, we strive to maintain transparency and fairness in all our financial dealings. As a non-profit organization, any funds collected are directed towards educational initiatives, community development, and alumni engagement activities. However, we understand that there may be occasions where a refund is requested.
      </p>

      <h2 style={heading}>Eligibility for Refunds:</h2>
      <p style={paragraph}>
        <strong>Membership Fees:</strong> Membership fees are generally non-refundable. Exceptions may be made if a duplicate payment was made or if a payment was made in error.
      </p>

      <h2 style={heading}>Refund Request Process:</h2>
      <p style={paragraph}>
        To request a refund, please contact us via email at{" "}
        <a href="mailto:alumni@std.uwu.ac.lk" style={email}>
          alumni@std.uwu.ac.lk
        </a>{" "}
        with the following details:
      </p>

      <ul style={list}>
        <li style={listItem}>Full Name</li>
        <li style={listItem}>Transaction Details (including date and amount)</li>
        <li style={listItem}>Reason for Refund Request</li>
      </ul>

      <p style={paragraph}>
        All approved refunds will be processed within 14 working days through the original mode of payment.
      </p>
    </div>
    <Footer/>
    </div>
  );
};

export default Refund;